import { useEffect, useRef, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { INSERT_UPDATE_DELIVERY } from '../graphql/Mutation/Delivery.js';
import { toast } from 'react-toastify';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import SpinLoader from '../components/SpinLoader.js';
import useScrollToTop from '../components/useScrollToTop.js';
import { GET_DELIVERY_ADDRESS_BY_ID } from '../graphql/Query/GetDeliveryOfCustomer.js';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { GET_VILLAGES_BY_PINCODE } from '../graphql/Query/Order.js';
import { PINCODE_SERVICEABLE } from '../graphql/Query/Order.js';

const DeliveryDetailsModel = ({ setDeliveryId, deliveryId, show, customerId, onClose, refetch, setdeliveryModal, setdeliveryShowModal, deliveryAddress, setDeliveryAddress, setSelectedDeliveryAddress, onSelectAddress }) => {
    const navigate = useNavigate();
    useScrollToTop();
    const [isVillageCase, setIsVillageCase] = useState(false);
    const [villageWarningMessage, setVillageWarningMessage] = useState("");

    const dropdownRef = useRef(null);
    const [checkServiceability] = useLazyQuery(PINCODE_SERVICEABLE, {
        fetchPolicy: "cache-and-network"
    });
    const [pincodeInfo, setPincodeInfo] = useState(null);
    console.log('✌️pincodeInfo --->', pincodeInfo);
    const [showDropdown, setShowDropdown] = useState(false);
    const [showVillageField, setShowVillageField] = useState(false);
    const [selectedVillageInfo, setSelectedVillageInfo] = useState(null);
    console.log('✌️selectedVillageInfo --->', selectedVillageInfo);
    const [showRoute, setShowRoute] = useState(false);
    console.log('✌️showRoute --->', showRoute);
    const [isDestinationServiceable, setIsDestinationServiceable] = useState(true);
    const [villagesData, setVillageOptionsData] = useState([]);
    const [villages, setVillageOptions] = useState([]);
    console.log('✌️villages --->', villages);
    const [villageSearch, setVillageSearch] = useState('');
    const [filteredVillages, setfilteredVillages] = useState("");
    const [initialValues, setInitialValues] = useState({
        name: '',
        address1: '',
        zipCode: '',
        city: '',
        stateId: '',
        phone: '',
        alternatePhone: '',
        email: "",
    });
    const [fetchVillagesByPincode] = useLazyQuery(GET_VILLAGES_BY_PINCODE, {
        fetchPolicy: "cache-and-network",
        onCompleted: (data) => {
            const pincodeData = data?.getVillagesByPincode || null;
            setPincodeInfo(pincodeData);

            const villages = pincodeData?.villages || [];
            setVillageOptionsData(villages);
            setVillageOptions(villages.map(v => v?.name));

            if (villages?.length === 0) {
                setShowVillageField(false);
                setShowRoute(false);
                setSelectedVillageInfo(null);
                return; // IMPORTANT — stop here
            }


            // ✅ If only one village (means it's a direct village pincode)
            if (villages.length === 1) {
                const village = villages[0];
                setSelectedVillageInfo(village);
                setfilteredVillages([village?.name]); // show only that one
                setVillageOptions([village?.name]); // dropdown list = single village
                setShowVillageField(true); // SHOW FIELD
                return;
            }
            // CASE 3: Multiple villages → show dropdown & radio buttons
            setShowVillageField(true);
        },

        onError: () => {
            setVillageOptions([]);
            setShowVillageField(false);
            setPincodeInfo(null);
        },
    });

    const [insertUpdateDelivery, { loading }] = useMutation(INSERT_UPDATE_DELIVERY);

    const { data: getDeliveryAddressById } = useQuery(GET_DELIVERY_ADDRESS_BY_ID, {
        variables: {
            getDeliveryDetailsByIdId: deliveryId || null,
        },
        fetchPolicy: "cache-and-network"
    });
    //     useEffect(() => {
    //     if (getDeliveryAddressById) {
    //         const pincode = getDeliveryAddressById?.getDeliveryDetailsById?.zipCode;
    //         if (pincode?.length === 6) {
    //             fetchVillagesByPincode({ variables: { pincode: parseInt(pincode, 10) } });
    //         }
    //     }
    // }, [getDeliveryAddressById]);

    useEffect(() => {
        if (getDeliveryAddressById) {
            const pincode = getDeliveryAddressById?.getDeliveryDetailsById?.zipCode;
            if (pincode?.length === 6) {
                fetchVillagesByPincode({ variables: { pincode: parseInt(pincode, 10) } });
            }
            setInitialValues({
                name: getDeliveryAddressById?.getDeliveryDetailsById?.name || '',
                address1: getDeliveryAddressById?.getDeliveryDetailsById?.address1 || '',
                zipCode: getDeliveryAddressById?.getDeliveryDetailsById?.zipCode || '',
                city: getDeliveryAddressById?.getDeliveryDetailsById?.city || '',
                stateId: getDeliveryAddressById?.getDeliveryDetailsById?.stateId || '',
                phone: getDeliveryAddressById?.getDeliveryDetailsById?.phone || '',
                alternatePhone: getDeliveryAddressById?.getDeliveryDetailsById?.alternatePhone || '',
                email: getDeliveryAddressById?.getDeliveryDetailsById?.email || '',
                village: getDeliveryAddressById?.getDeliveryDetailsById?.VillageName || '',
            });
            // Pre-populate selectedVillageInfo
            const selected = villagesData?.find(v => v?.name === getDeliveryAddressById.getDeliveryDetailsById?.VillageName);
            setSelectedVillageInfo(selected);

            // Set other states if needed
            setShowRoute(getDeliveryAddressById.getDeliveryDetailsById?.isDeliverToVillage ?? false);
        }
    }, [getDeliveryAddressById]);

    useEffect(() => {
        const filteredVillagesData = villages?.filter(v =>
            v.toLowerCase().includes(villageSearch?.toLowerCase())
        );
        setfilteredVillages(filteredVillagesData);
    }, [villages, villageSearch])

    const handlePincodeCheck = async (type, pincode) => {
        try {
            const variables = { destinationPincode: Number(pincode) };
            const { data } = await checkServiceability({ variables });

            if (!data?.checkPincodeServiceability) return false;

            const result = data.checkPincodeServiceability;

            // --- Village case ---
            if (
                result.destination === false &&
                result.destinationReason === "VILLAGE_NOT_SERVICEABLE_COLLECT_FROM_MAIN_BRANCH"
            ) {
                setIsVillageCase(true);
                setIsDestinationServiceable(true); // <-- important: TRUE
                const msg = `Delivery village not serviceable. Receiver must COLLECT parcel from:
                ${result.destinationLastCenter?.officeMainArea
                        ? result?.destinationLastCenter.officeMainArea + ", "
                        : ""}${result?.destinationLastCenter?.officeCity} - ${result?.destinationMainPincode}`;

                toast.info(msg);

                setVillageWarningMessage(msg); // <-- Save message for UI
                // IMPORTANT: Do NOT show village dropdown here
                setShowVillageField(false);
                setShowRoute(false);

                return true;
            }

            // --- Fully Not Serviceable ---
            if (result.destination === false) {
                setIsVillageCase(false);
                setIsDestinationServiceable(false);
                toast.error("Destination pincode is NOT serviceable");
                return false;
            }

            // --- Fully Serviceable ---
            setIsVillageCase(false);
            setIsDestinationServiceable(true);
            return true;

        } catch (error) {
            setIsDestinationServiceable(false);
            setIsVillageCase(false);
            toast.error("Unable to check serviceability");
            return false;
        }
    };


    const handlePincodeChange = async (event, setFieldValue) => {
        const pincode = event?.target?.value?.trim();
        setFieldValue('zipCode', pincode);
        setFieldValue('village', "");

        // ✅ As soon as user starts typing new pincode, clear previous village data
        setVillageOptions([]);
        setfilteredVillages([]);
        setVillageOptionsData([]);
        setSelectedVillageInfo(null);
        setShowVillageField(false);
        setShowDropdown(false);
        setShowRoute(false);
        setIsDestinationServiceable(true);
        setIsVillageCase(false);
        setVillageWarningMessage("");

        if (pincode?.length === 6) {
            try {
                const serviceable = await handlePincodeCheck("destination", pincode); // ✅ use return value
                // Continue only if serviceable
                if (serviceable) {
                    await fetchVillagesByPincode({
                        variables: { pincode: parseInt(pincode, 10) }
                    });

                    const response = await axios.get(`https://api.postalpincode.in/pincode/${pincode}`);
                    const data = response?.data;
                    if (data[0].Status === 'Success') {
                        const { District, State } = data[0].PostOffice[0];
                        setFieldValue('city', District);
                        setFieldValue('stateId', State);
                    }
                }
            } catch (error) {
                console.error(error);
            }
        }
    };

    const handlestateIdChange = async (event, setFieldValue) => {
        const state = event.target.value.trim();
        setFieldValue('stateId', state);
    }
    const handleCityChange = async (event, setFieldValue) => {
        const city = event.target.value.trim();
        setFieldValue('city', city);
    }
    const inserUpdateDelivery = async (values, { setSubmitting }) => {
        if (!isDestinationServiceable && !isVillageCase) {
            toast.error("Destination pincode is NOT serviceable. Please change it before continuing.");
            return;
        }


        const enteredPincode = parseInt(values?.zipCode, 10);
        if (showRoute === true && pincodeInfo?.villages?.length > 0) {
            // Case 1: No village selected
            if (!selectedVillageInfo) {
                toast.error("Please select a receiver village.");
                setShowRoute(false);
                return;
            }

            // Case 2: Selected village not serviceable
            if (!selectedVillageInfo?.isServiceAvailable) {
                toast.error(`Village ${selectedVillageInfo?.name || ""} is not serviceable.`);
                setShowRoute(false);
                setSelectedVillageInfo(null);
                return;
            }

            // Case 3: Selected village pincode mismatch
            if (
                selectedVillageInfo?.pincode !== enteredPincode &&
                enteredPincode !== pincodeInfo?.pincode
            ) {
                toast.error("Selected village does not match the entered pincode.");
                setShowRoute(false);
                setSelectedVillageInfo(null);
                return;
            }
        }


        try {
            const { data } = await insertUpdateDelivery({
                variables: {
                    input: {
                        id: deliveryId ? deliveryId : '',
                        "address1": values?.address1,
                        "city": values?.city,
                        "name": values?.name,
                        "zipCode": values?.zipCode,
                        "phone": values?.phone,
                        "email": values?.email,
                        "alternateMobileNumber": values?.alternatePhone,
                        "stateId": values?.stateId,
                        isDeliverToVillage: selectedVillageInfo?.isServiceAvailable && showRoute === true ? true : false,
                        VillageName: selectedVillageInfo?.name,
                        distanceFromTalukaKm: selectedVillageInfo?.distanceFromTalukaKm,
                        extraChargeOfVillage: selectedVillageInfo?.isServiceAvailable && showRoute === true ? selectedVillageInfo?.extraCharge : 0,
                        ...(customerId && { customerId })
                    }
                }
            });
            if (data?.insertUpdateDelivery) {
                setSelectedDeliveryAddress && setSelectedDeliveryAddress(data?.insertUpdateDelivery);
                onSelectAddress && onSelectAddress(data?.insertUpdateDelivery);
                if (deliveryId) {
                    toast.success("Delivery Address Updated Successfully")
                } else {
                    toast.success("Delivery Address Added Successfully");
                }
                setDeliveryId && setDeliveryId("");
                setShowRoute(false);
                setShowVillageField(false);
                setIsVillageCase(false); setVillageWarningMessage("");
                setDeliveryAddress && setDeliveryAddress('');
                if (customerId) {
                    navigate("/");
                }
                refetch && refetch();
                setdeliveryModal && setdeliveryModal(false);
                setdeliveryShowModal && setdeliveryShowModal(false);
                // onClose();
            }
        } catch (err) {
            toast.error(err?.message);
        }
    };
    const validationSchema = Yup.object({
        name: Yup.string()
            .required('Name is required')
            .min(2, 'Name must be at least 2 characters long')
            .max(100, 'Name must be at most 100 characters long')
            .matches(/^[A-Za-z\s,.]+$/, 'Name can only contain letters, spaces, commas, and periods'),

        phone: Yup.string()
            .required('Mobile number is required')
            .matches(/^[0-9]{10}$/, 'Mobile number must be exactly 10 digits'),

        address1: Yup.string()
            .required('Address is required')
            .min(6, 'Address must be at least 6 characters long')
            .max(150, 'Address must be at most 150 characters long'),

        zipCode: Yup.string()
            .required('Pincode is required')
            .matches(/^[0-9]{6}$/, 'Pincode must be exactly 6 digits'),

        city: Yup.string()
            .required('City is required')
            .min(2, 'City must be at least 2 characters long')
            .max(40, 'City must be at most 40 characters long')
            .matches(/^[A-Za-z\s,.]+$/, 'City can only contain letters, spaces, commas, and periods'),

        stateId: Yup.string()
            .required('State is required')
            .min(2, 'State must be at least 2 characters long')
            .max(40, 'State must be at most 40 characters long')
            .matches(/^[A-Za-z\s,.]+$/, 'State can only contain letters, spaces, commas, and periods'),
        alternatePhone: Yup.string()
            .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
            .optional(),
        email: Yup.string()
            .email("Invalid email address")
            .optional(), // 👈 Not required but must be valid if filled
    });
    const handleChange = (e, setFieldValue, fieldName) => {
        const cleanedValue = e.target.value.replace(/\s+/g, '');
        setFieldValue(fieldName, cleanedValue);
    };

    return (
        <>
            <Transition show={show}>
                <Dialog className="relative z-50" onClose={onClose}>
                    <Transition.Child
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-50 w-screen h-screen overflow-y-auto">
                        <div className="flex min-h-full items-start justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative w-screen transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg lg:max-w-xl xl:max-w-2xl 2xl:max-w-7xl">
                                    <div className="h-[auto] overflow-y-auto bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                                        <div>
                                            <div className="mb-4">
                                                <h2 className="text-xl font-bold">Add Delivery Address</h2>
                                            </div>
                                            <p className='border border-gray-100'></p>
                                            <Formik

                                                enableReinitialize={true}
                                                initialValues={initialValues}
                                                validationSchema={validationSchema}
                                                onSubmit={inserUpdateDelivery}
                                            >
                                                {({ isSubmitting, setFieldValue, errors, touched, values }) => (
                                                    <Form className="mt-6">
                                                        <div>
                                                            <h4 className="font-bold text-gray-800 mb-4">Delivery Contact Details</h4>
                                                            <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-4">
                                                                <div>
                                                                    <label className="block text-sm font-medium text-gray-700">Name <span className="text-red-500">*</span></label>
                                                                    <Field
                                                                        type="text"
                                                                        name="name"
                                                                        placeholder="Name"
                                                                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-slate-600 focus:border-slate-600 sm:text-sm"
                                                                    />
                                                                    <ErrorMessage name="name" component="div" className="text-red-500 text-xs mt-1" />
                                                                </div>
                                                                <div>
                                                                    <label className="block text-sm font-medium text-gray-700">
                                                                        Mobile Number <span className="text-red-500">*</span>
                                                                    </label>
                                                                    <div className="mt-1 flex rounded-md shadow-sm">
                                                                        <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-slate-50 text-gray-500 sm:text-sm">
                                                                            +91
                                                                        </span>
                                                                        <Field
                                                                            type="number"
                                                                            name="phone"
                                                                            onWheel={(e) => e.target.blur()}
                                                                            placeholder="Mobile Number"
                                                                            onChange={(e) => handleChange(e, setFieldValue, "phone")}
                                                                            className="flex-1 block w-full px-3 py-2 border border-gray-300 rounded-r-md focus:outline-none focus:ring-slate-600 focus:border-slate-600 sm:text-sm"
                                                                        />
                                                                    </div>
                                                                    <ErrorMessage name="phone" component="div" className="text-red-500 text-xs mt-1" />
                                                                    <p className="mt-1 text-xs text-gray-500">We’ll call this number to coordinate pickup</p>
                                                                </div>

                                                                <div>
                                                                    <label className="block text-sm font-medium text-gray-700">
                                                                        Alternate Phone Number
                                                                    </label>
                                                                    <div className="mt-1 flex rounded-md shadow-sm">
                                                                        <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-slate-50 text-gray-500 sm:text-sm">
                                                                            +91
                                                                        </span>
                                                                        <Field
                                                                            type="number"
                                                                            name="alternatePhone"
                                                                            onWheel={(e) => e.target.blur()}
                                                                            placeholder="Alternate Phone Number"
                                                                            onChange={(e) => handleChange(e, setFieldValue, "alternatePhone")}
                                                                            className="flex-1 block w-full px-3 py-2 border border-gray-300 rounded-r-md focus:outline-none focus:ring-slate-600 focus:border-slate-600 sm:text-sm"
                                                                        />
                                                                    </div>
                                                                    <ErrorMessage
                                                                        name="alternatePhone"
                                                                        component="div"
                                                                        className="text-red-500 text-xs mt-1"
                                                                    />
                                                                    <p className="mt-1 text-sm text-green-500">
                                                                        Optional – in case we cannot reach your primary number
                                                                    </p>
                                                                </div>

                                                                <div>
                                                                    <label className="block text-sm font-medium text-gray-700">
                                                                        Email Address
                                                                    </label>
                                                                    <div className="mt-1 flex rounded-md shadow-sm">
                                                                        <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-slate-50 text-gray-500 sm:text-sm">
                                                                            📧
                                                                        </span>
                                                                        <Field
                                                                            type="email"
                                                                            name="email"
                                                                            placeholder="Enter your Email Address"
                                                                            onChange={(e) => handleChange(e, setFieldValue, "email")}
                                                                            className="flex-1 block w-full px-3 py-2 border border-gray-300 rounded-r-md focus:outline-none focus:ring-slate-600 focus:border-slate-600 sm:text-sm"
                                                                        />
                                                                    </div>
                                                                    <ErrorMessage
                                                                        name="email"
                                                                        component="div"
                                                                        className="text-red-500 text-xs mt-1"
                                                                    />
                                                                    <p className="mt-1 text-sm text-green-500">
                                                                        Optional – we’ll send live tracking updates to this email
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <h4 className="font-bold text-gray-800 mb-4 mt-7 md:mt-4">Address Details</h4>
                                                            <div className="mt-2 space-y-4">
                                                                <div>
                                                                    <label className="block text-sm font-medium text-gray-700">Flat, Housing no., Building, Apartment - Area, street, sector <span className="text-red-500">*</span></label>
                                                                    <Field
                                                                        type="text"
                                                                        name="address1"
                                                                        placeholder="Flat, Housing no., Building, Apartment - Area, street, sector"
                                                                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-slate-600 focus:border-slate-600 sm:text-sm"
                                                                    />
                                                                    <ErrorMessage name="address1" component="div" className="text-red-500 text-xs mt-1" />
                                                                </div>
                                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                                    <div>
                                                                        <label className="block text-sm font-medium text-gray-700">Pincode <span className="text-red-500">*</span></label>
                                                                        <Field
                                                                            type="text"
                                                                            name="zipCode"
                                                                            placeholder="Enter pincode"
                                                                            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-slate-600 focus:border-slate-600 sm:text-sm"
                                                                            onChange={(event) => handlePincodeChange(event, setFieldValue)}
                                                                        />
                                                                        {!isDestinationServiceable && !isVillageCase && (
                                                                            <div className="text-red-500 text-sm mt-1">
                                                                                This pincode is NOT serviceable.
                                                                            </div>
                                                                        )}
                                                                        {/* ⚠️ Village not serviceable but main branch possible */}
                                                                        {isVillageCase && villageWarningMessage && (
                                                                            <div className="text-yellow-600 text-sm mt-1">
                                                                                {villageWarningMessage}
                                                                            </div>
                                                                        )}
                                                                        <ErrorMessage name="zipCode" component="div" className="text-red-500 text-sm" />
                                                                    </div>
                                                                    <div>
                                                                        <label className="block text-sm font-medium text-gray-700">City <span className="text-red-500">*</span></label>
                                                                        <Field
                                                                            type="text"
                                                                            name="city"
                                                                            placeholder="Enter city"
                                                                            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-slate-600 focus:border-slate-600 sm:text-sm"
                                                                            // value={locationData.city}
                                                                            // value={values.city}
                                                                            onChange={(event) => handleCityChange(event, setFieldValue)}
                                                                        />
                                                                        <ErrorMessage name="city" component="div" className="text-red-500 text-sm" />
                                                                    </div>
                                                                </div>
                                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                                    <div>
                                                                        <label className="block text-sm font-medium text-gray-700">State <span className="text-red-500">*</span></label>
                                                                        <Field
                                                                            type="text"
                                                                            name="stateId"
                                                                            placeholder="Enter state"
                                                                            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-slate-600 focus:border-slate-600 sm:text-sm"
                                                                            // value={locationData?.state}
                                                                            // value={values.stateId}
                                                                            onChange={(event) => handlestateIdChange(event, setFieldValue)}
                                                                        />
                                                                        <ErrorMessage name="stateId" component="div" className="text-red-500 text-sm" />
                                                                    </div>
                                                                </div>
                                                                {showVillageField && isDestinationServiceable && !isVillageCase && (
                                                                    <>
                                                                        {
                                                                            <label className="block text-sm font-medium text-slate-700 mb-1">
                                                                                Receiver Village <span className="text-red-500">*</span>
                                                                            </label>}
                                                                        {showRoute === true &&

                                                                            <div className="relative" ref={dropdownRef}>

                                                                                <div
                                                                                    className={`w-full px-4 py-2 bg-blue-50 rounded-md border text-sm placeholder-gray-600 focus:outline-none focus:ring-1 focus:ring-slate-900 ${errors?.village && touched?.village
                                                                                        ? 'border-red-500'
                                                                                        : 'border-zinc-300'
                                                                                        }`}
                                                                                    onClick={() => setShowDropdown(prev => !prev)}
                                                                                >
                                                                                    {values?.village || 'Select village'}
                                                                                </div>
                                                                                <ErrorMessage
                                                                                    name="village"
                                                                                    component="div"
                                                                                    className="text-red-500 text-sm mt-1"
                                                                                />

                                                                                {showDropdown && (
                                                                                    <div className="absolute z-10 mt-1 w-full bg-blue-50 border rounded-md max-h-60 overflow-y-auto">
                                                                                        <input
                                                                                            type="text"
                                                                                            placeholder="Search village..."
                                                                                            className="w-full bg-blue-50 px-3 py-3 border-b outline-none"
                                                                                            value={villageSearch}
                                                                                            onChange={e => setVillageSearch(e.target.value)}
                                                                                        />
                                                                                        {filteredVillages?.map((village, idx) => (
                                                                                            <div
                                                                                                key={idx}
                                                                                                onClick={() => {
                                                                                                    setFieldValue('village', village);
                                                                                                    setShowDropdown(false);
                                                                                                    setVillageSearch('');

                                                                                                    // Save the full village object (not just name)
                                                                                                    const selected = villagesData?.find(v => v?.name === village); // FIXED: using villagesData (array)
                                                                                                    // console.log('✌️villages --->', villagesData);
                                                                                                    // console.log('✌️selected --->', selected);

                                                                                                    setSelectedVillageInfo(selected); // ✅ This stores the selected village info properly
                                                                                                }}
                                                                                                className="px-4 py-2.5 text-gray-800 hover:bg-slate-700 hover:text-white active:bg-slate-800 cursor-pointer"
                                                                                            >
                                                                                                {village}
                                                                                            </div>
                                                                                        ))}
                                                                                        {filteredVillages?.length === 0 && (
                                                                                            <div className="px-4 py-2.5 text-sm text-gray-400">No match found</div>
                                                                                        )}
                                                                                    </div>
                                                                                )}

                                                                            </div>
                                                                        }
                                                                        <div className="space-y-1 mt-1">
                                                                            {/* Radio Buttons */}
                                                                            <div className="flex items-center gap-8 bg-blue-50 p-2 rounded-lg border border-gray-200">
                                                                                {/* Yes Option */}
                                                                                <label className="flex items-center gap-2 cursor-pointer">
                                                                                    <input
                                                                                        type="radio"
                                                                                        name="showRoute"
                                                                                        value="yes"
                                                                                        checked={showRoute === true}
                                                                                        onChange={() => { setShowRoute(true); setShowVillageField(true); }}
                                                                                        className="w-4 h-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                                                                                    />
                                                                                    <span className="text-gray-800 text-sm font-medium">Yes, Deliver (Village)</span>
                                                                                </label>

                                                                                {/* No Option */}
                                                                                <label className="flex items-center gap-2 cursor-pointer">
                                                                                    <input
                                                                                        type="radio"
                                                                                        name="showRoute"
                                                                                        value="no"
                                                                                        checked={showRoute === false}
                                                                                        onChange={() => { setShowRoute(false); setSelectedVillageInfo(null); setFieldValue('village', ""); }}
                                                                                        className="w-4 h-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                                                                                    />
                                                                                    <span className="text-gray-800 text-sm font-medium">No, Self Collect</span>
                                                                                </label>
                                                                            </div>

                                                                            {/* Route Info or Message */}
                                                                            {/* Route Info or Message */}
                                                                            {selectedVillageInfo ? (
                                                                                showRoute === false ? (
                                                                                    <div className="bg-red-50 border border-red-200 rounded-lg p-2 text-red-600 text-sm font-medium">
                                                                                        {/* Self collect to {selectedVillageInfo?.name} */}
                                                                                        No, Self Collect {pincodeInfo?.lastCenter?.officeMainArea ? pincodeInfo?.lastCenter?.officeMainArea : ""} {pincodeInfo?.lastCenter?.officeCity} - {pincodeInfo?.lastCenter?.officePincode}
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="text-gray-700 text-sm bg-blue-50 rounded-lg p-2 border border-slate-100 mt-2 space-y-2">
                                                                                        <div className="flex justify-between">
                                                                                            <span>Village:</span>
                                                                                            <span className="font-medium">{selectedVillageInfo?.name}</span>
                                                                                        </div>
                                                                                        <div className="flex justify-between">
                                                                                            <span>Distance from Taluka:</span>
                                                                                            <span className="font-medium">{selectedVillageInfo?.distanceFromTalukaKm} KM</span>
                                                                                        </div>
                                                                                        <div className="flex justify-between">
                                                                                            <span>Extra Charge:</span>
                                                                                            <span className="font-medium">₹ {selectedVillageInfo?.extraCharge}</span>
                                                                                        </div>
                                                                                        <div className="flex justify-between">
                                                                                            <span>Service Available:</span>
                                                                                            <span className={`font-medium ${selectedVillageInfo?.isServiceAvailable ? 'text-green-600' : 'text-red-600'}`}>
                                                                                                {selectedVillageInfo?.isServiceAvailable ? 'Yes' : 'No'}
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                )
                                                                            ) : null}
                                                                        </div>
                                                                    </>
                                                                )}

                                                            </div>
                                                        </div>
                                                        <button
                                                            type="submit"
                                                            className="mt-6 inline-flex w-full justify-center rounded-md bg-slate-900 px-3 py-2.5 text-sm font-semibold text-white shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-slate-900 sm:mt-7"
                                                            disabled={loading}
                                                        >
                                                            {loading ? (
                                                                <div className='flex justify-center'>
                                                                    <span className='me-2'>Add Delivery Address</span>
                                                                    <SpinLoader />
                                                                </div>
                                                            ) : (
                                                                'Add Delivery Address'
                                                            )}
                                                        </button>
                                                    </Form>
                                                )}
                                            </Formik>
                                        </div>
                                    </div>
                                    <div className="bg-slate-50 px-4 py-3 sm:px-6 space-y-2">
                                        <button
                                            type="button"
                                            className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-slate-50 sm:mt-0"
                                            onClick={() => { onClose(); setShowVillageField(false); setIsVillageCase(false); setVillageWarningMessage(""); }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}

export default DeliveryDetailsModel;

